import galaxy from "./galaxy-cn";
import home from "./home-cn";
import footer from "./footer-cn";
import matrix from "./matrix-cn";
import soul from "./soul-cn";
import verse from "./verse-cn";
import news from "./news-cn";
export default {
  home,
  galaxy,
  matrix,
  footer,
  soul,
  verse,
  news,
};
